export default [
  {
    path: '/card/card-basic',
    name: 'card-basic',
    component: () => import('@/views/card/card-basic/CardBasic.vue'),
    meta: {
      resource: 'demo',
      action: 'read',
      pageTitle: 'Basic Card',
      breadcrumb: [
        {
          text: 'Card',
        },
        {
          text: 'Basic Card',
          active: true,
        },
      ],
    },
  },
  {
    path: '/card/card-advance',
    name: 'card-advance',
    component: () => import('@/views/card/card-advance/CardAdvance.vue'),
    meta: {
      resource: 'demo',
      action: 'read',
      pageTitle: 'Advance Card',
      breadcrumb: [
        {
          text: 'Card',
        },
        {
          text: 'Advance Card',
          active: true,
        },
      ],
    },
  },
  {
    path: '/card/statistic',
    name: 'card-statistic',
    component: () => import('@/views/card/card-statistic/CardStatistic.vue'),
    meta: {
      resource: 'demo',
      action: 'read',
      pageTitle: 'Statistics Cards',
      breadcrumb: [
        {
          text: 'Card',
        },
        {
          text: 'Statistics Cards',
          active: true,
        },
      ],
    },
  },
  {
    path: '/card/analytic',
    name: 'card-analytic',
    component: () => import('@/views/card/card-analytic/CardAnalytic.vue'),
    meta: {
      resource: 'demo',
      action: 'read',
      pageTitle: 'Analytics Cards',
      breadcrumb: [
        {
          text: 'Card',
        },
        {
          text: 'Analytics Cards',
          active: true,
        },
      ],
    },
  },
  {
    path: '/card/action',
    name: 'card-action',
    component: () => import('@/views/card/card-action/CardAction.vue'),
    meta: {
      resource: 'demo',
      action: 'read',
      pageTitle: 'Card Actions',
      breadcrumb: [
        {
          text: 'Card',
        },
        {
          text: 'Card Actions',
          active: true,
        },
      ],
    },
  },
]
